import { gql } from '@apollo/client';

export default gql`
  mutation blockMatch($input: BlockMatchInput!) {
    blockMatch(input: $input) {
      id
    }
  }
`;
